import { Grid, Paper, Typography } from '@mui/material';

const PromptItem = ({ label, value, xs = 3 }) => (
  <Grid item xs={6} sm={xs}>
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: 'white',
        borderRadius: '12px',
        height: '100%',
        transition: 'all 0.2s ease-in-out',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        border: '1px solid #f8f9fa',
        '&:hover': {
          backgroundColor: '#f8f9ff',
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(146, 145, 239, 0.15)',
          borderColor: '#9291ef',
        },
      }}
    >
      <Typography
        variant='caption'
        sx={{
          color: '#6c757d',
          fontWeight: 500,
          display: 'block',
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant='body2'
        component='span'
        sx={{
          color: '#2c3e50',
          fontWeight: 600,
          fontSize: '0.9rem',
        }}
      >
        {value}
      </Typography>
    </Paper>
  </Grid>
);

export default PromptItem;

